import React from "react";
import "./TechnoJunior.css";
import useScrollAnimation from "../constants/useScrollAnimation";

export default function TechnoJunior() {
  const [contentRef, isContentVisible] = useScrollAnimation(0.2);

  return (
    <section className="section-techno-junior">
      <div ref={contentRef} className="techno-junior">
        <div className={`techno-junior-lt schools-left ${isContentVisible ? "animate-in" : ""}`}>
          <img
            src="/images/juinor/techno_junior_logo.png"
            className="techno-juniorr-logo"
            alt="Techno Junior Logo"
          />

          <div className="section-title-body">
            <div>
              <h3 className="section-title-hm">Techno Junior</h3>
            </div>

          </div>



          <p className="techno-junior-contain body-txt mb-5">
            Techno Junior is dedicated to providing a foundation for your
            child’s education with international standards. We are committed to
            delivering everything necessary for an exciting and enriching start
            to your child's learning journey. Techno Junior aims to offer a
            joyful experience that ensures a smooth transition into formal
            education. As a leading preschool in India, Techno Junior introduces
            “Education 4.0” to the young minds of Generation Y. Drawing on years
            of extensive research and experience, Techno Junior focuses on the
            holistic development of children in an environment that promotes
            freedom beyond the traditional classroom.
          </p>
          <a href="#" class="btn-com school-view mt-5"> Go To The Site</a>
        </div>

        <div className={`techno-junior-rt schools-right ${isContentVisible ? "animate-in" : ""}`}>
          <img src="./images/juinor/junior_section.png" alt="" />
        </div>
      </div>
    </section>
  );
}
